import { Stack } from '@mui/material';
import { FC } from 'react';

interface Props {
  instrumentName: string;
  instrumentIsin: string;
}

export const B2bInvestorProfileGridColumnHeader: FC<Props> = (props) => {
  const { instrumentIsin, instrumentName } = props;

  return (
    <Stack spacing={1}>
      <div style={{ height: 80, width: 160 }}>
        <span style={{ fontWeight: 'bold' }}>{instrumentName}</span>
      </div>
      <span>{instrumentIsin}</span>
    </Stack>
  );
};
